(function () {
  'use strict';

  var cfg = window.PLATFORM_FEE || {};
  if (!cfg.variantId || !cfg.percent) {
    console.warn('[platform-fee] not active', cfg);
    return;
  }
  console.log('[platform-fee] loaded', cfg);

  var FEE_ID = Number(cfg.variantId);
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  // .eosh-payment_button = the OTP login app's replacement Buy it now button
  var BUY_NOW = '[data-pf-buy-now], .eosh-payment_button, .shopify-payment-button__button--unbranded';
  var CHECKOUT = 'button[name="checkout"], input[name="checkout"], a[href$="/checkout"]';
  var SAVED_KEY = 'pf_saved_cart'; // cart lines parked during Buy it now
  var busy = false;

  function request(path, body) {
    return fetch(root + path, body && {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(path + ' failed (' + r.status + ')');
      return r.json();
    });
  }

  function logError(err) {
    console.error('[platform-fee]', err);
  }

  // base = sum of original_line_price (before discounts; final_line_price = after discounts)
  function feeQty(base) {
    return Math.round((base / 100) * cfg.percent / 100); // paise -> rupees -> fee qty
  }

  function savedCart(lines) {
    try {
      if (lines === undefined) return JSON.parse(localStorage.getItem(SAVED_KEY));
      if (lines) localStorage.setItem(SAVED_KEY, JSON.stringify(lines));
      else localStorage.removeItem(SAVED_KEY);
    } catch (e) {
      return null;
    }
  }

  /* ---------- checkout ---------- */

  function addFeeAndCheckout() {
    return request('cart.js').then(function (cart) {
      var base = 0;
      var inCart = 0;
      cart.items.forEach(function (i) {
        if (i.variant_id === FEE_ID) inCart = i.quantity;
        else base += i.original_line_price;
      });
      var qty = feeQty(base);
      if (qty === inCart) return;
      return inCart
        ? request('cart/change.js', { id: String(FEE_ID), quantity: qty })
        : request('cart/add.js', { items: [{ id: FEE_ID, quantity: qty }] });
    }).then(goToCheckout);
  }

  function goToCheckout() {
    if (!window.EOSH || window.EOSH.appReady !== true) {
      window.location.href = root + 'checkout';
      return;
    }
    var el = document.createElement('span');
    el.className = 'eosh_buttonCheckout';
    el.hidden = true;
    document.body.appendChild(el);
    el.click();
    el.remove();
    busy = false; // the popup may stay open; don't block the next click
  }

  function buyNow(btn) {
    var form = btn.closest('form') || document.querySelector('form[action*="/cart/add"]');
    var id = form && form.querySelector('[name="id"]');
    if (!id || !id.value) return Promise.reject(new Error('Product form or variant not found'));
    var qty = form.querySelector('[name="quantity"]');
    var item = { id: Number(id.value), quantity: (qty && parseInt(qty.value, 10)) || 1 };

    return request('cart.js').then(function (cart) {
      if (!savedCart()) { // keep the original cart if an earlier Buy it now is still parked
        savedCart(cart.items.filter(function (i) { return i.variant_id !== FEE_ID; }).map(function (i) {
          var plan = i.selling_plan_allocation;
          return { id: i.variant_id, quantity: i.quantity, properties: i.properties, selling_plan: plan && plan.selling_plan.id };
        }));
      }
      return request('cart/clear.js', {});
    }).then(function () {
      return request('cart/add.js', { items: [item] });
    }).then(function (added) {
      var qty = feeQty(added.items.reduce(function (sum, i) { return sum + i.original_line_price; }, 0));
      if (qty > 0) return request('cart/add.js', { items: [{ id: FEE_ID, quantity: qty }] });
    }).then(goToCheckout);
  }

  window.addEventListener('click', function (e) {
    if (!(e.target instanceof Element)) return;
    var buy = e.target.closest(BUY_NOW);
    var checkout = !buy && e.target.closest(CHECKOUT);
    if (checkout && checkout.closest('.shopify-payment-button')) return; // wallet buttons
    if (!buy && !checkout) return;

    e.preventDefault();
    e.stopPropagation();
    if (busy) return;
    busy = true;
    (buy ? buyNow(buy) : addFeeAndCheckout()).catch(function (err) {
      logError(err);
      busy = false;
      alert('Unable to start checkout. Please try again.');
    });
  }, true);

  /* ---------- back on the storefront: clean up the cart ---------- */

  function withSections(body) {
    body.sections = 'cart-drawer,cart-icon-bubble' +
      (document.querySelector('cart-items') ? ',main-cart,cart-live-region-text' : '');
    body.sections_url = window.location.pathname;
    return body;
  }

  function renderCart(state) {
    var drawer = document.querySelector('cart-drawer');
    var cartItems = document.querySelector('cart-items');
    if (drawer && typeof drawer.renderContents === 'function') {
      // With "lazy load JS" on, the drawer stays in <template class="deferred"> until first opened
      var deferred = drawer.querySelector('template.deferred');
      var target = deferred && deferred.content.querySelector('#CartDrawer');
      if (target) {
        target.innerHTML = drawer.getSectionInnerHTML(state.sections['cart-drawer'], '#CartDrawer');
        document.getElementById('cart-icon-bubble').innerHTML = drawer.getSectionInnerHTML(state.sections['cart-icon-bubble']);
      } else {
        drawer.renderContents(state, true);
      }
      drawer.classList.toggle('is-empty', state.item_count === 0);
    }
    if (cartItems && typeof cartItems.renderContents === 'function') cartItems.renderContents(state);
  }

  function restoreCart(lines) {
    savedCart(null);
    if (!lines.length) return request('cart/clear.js', withSections({}));
    return request('cart/clear.js', {}).then(function () {
      return request('cart/add.js', withSections({ items: lines }));
    });
  }

  function removeFee() {
    return request('cart/change.js', withSections({ id: String(FEE_ID), quantity: 0 }));
  }

  function cleanUp(feeInCart) {
    var lines = savedCart();
    var job = lines ? restoreCart(lines) : feeInCart ? removeFee() : null;
    if (job) job.then(renderCart).catch(logError);
  }

  // Normal page load: Liquid already told us whether the fee is in the cart, so act right away.
  cleanUp(cfg.inCart > 0);

  // Back/forward cache restore: old JS state (busy may be true) and old cart HTML, so re-check.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    busy = false;
    if (savedCart()) return cleanUp(false);
    request('cart.js').then(function (cart) {
      cleanUp(cart.items.some(function (i) { return i.variant_id === FEE_ID; }));
    }).catch(logError);
  });
})();
